import { PopperTooltip } from "~/common/components/Tooltip";
import { Icon } from "~/common/components/icon/Icon";
import { IconType } from "~/common/components/icon/IconType";

import classes from "./InfoCircle.module.less";
import type { ReactNode } from "react";
import classNames from "classnames";
import type { PopperPlacementType } from "@mui/material";

export const InfoCircle = ({
  className,
  tooltipClassName,
  content,
  placement = "bottom",
  disableFlip,
}: {
  className?: string;
  tooltipClassName?: string;
  content: ReactNode;
  placement?: PopperPlacementType;
  disableFlip?: boolean;
}) => {
  return (
    <PopperTooltip
      className={classNames(className, classes.infoCircle)}
      tooltipContent={content}
      placement={placement}
      innerClassName={classNames(classes.resetTooltip, tooltipClassName)}
      disableFlip={disableFlip}
    >
      <Icon type={IconType.InfoCircleOutline} />
    </PopperTooltip>
  );
};
